<template>
  <div>
    <ConstructionFolder :currentConstruction="currentConstruction" v-if="$route.name === 'create-kokuban-detail'" />
    <router-view :currentConstruction="currentConstruction" />
  </div>
</template>

<script>
export default {
  name: 'CreateKokubanFolder',
  components: {
    ConstructionFolder: () => import('../../components/cloud/CreKokuban/ConstructionFolder.vue')
  },
  props: {
    constructionList: Array
  },
  computed: {
    currentConstruction() {
      return this.constructionList.find(construction => construction.cloud_construction_id === this.$route.params.cloudConstructionId);
    }
  }
}
</script>

<style scoped>
</style>